export const STORAGE_KEY = 'mdview:last';

export function savePersisted(markdown: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, markdown);
  } catch {
    // QuotaExceeded or storage disabled — silently skip.
    // Rendering must continue to work without persistence.
  }
}

export function loadPersisted(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}
